import Card from "@/components/common/Card";
import { ConditionGroup } from "@/components/segments/conditions/ConditionEditor";

export default function Step2Targeting({
  definition,
  onAddCondition,
  onUpdateCondition,
  onRemoveCondition,
  fieldOptionConfig,
}) {
  return (
    <Card className="builder-form flex flex-col gap-5">
      <ConditionGroup
        title="Must match all of these"
        description="Every condition has to pass for a viewer to qualify."
        conditions={definition.all}
        onAdd={() => onAddCondition("all")}
        onUpdate={(id, next) => onUpdateCondition("all", id, next)}
        onRemove={(id) => onRemoveCondition("all", id)}
        fieldOptionConfig={fieldOptionConfig}
      />

      <ConditionGroup
        title="Match any of these"
        description="At least one condition must pass."
        conditions={definition.any}
        onAdd={() => onAddCondition("any")}
        onUpdate={(id, next) => onUpdateCondition("any", id, next)}
        onRemove={(id) => onRemoveCondition("any", id)}
        fieldOptionConfig={fieldOptionConfig}
      />

      <ConditionGroup
        title="Exclude viewers when"
        description="If any condition passes, the viewer is excluded."
        conditions={definition.none}
        onAdd={() => onAddCondition("none")}
        onUpdate={(id, next) => onUpdateCondition("none", id, next)}
        onRemove={(id) => onRemoveCondition("none", id)}
        fieldOptionConfig={fieldOptionConfig}
      />
    </Card>
  );
}
